import { createContext, useContext, type ReactNode } from "react";

export type RecordSelection = {
  onSelectRecord: (value: string) => void;
  selectionDisabled: boolean;
};

const RecordSelectionContext = createContext<RecordSelection | null>(null);

export function RecordSelectionProvider({ value, children }: { value: RecordSelection | null; children: ReactNode }) {
  return <RecordSelectionContext.Provider value={value}>{children}</RecordSelectionContext.Provider>;
}

export function useRecordSelection(): RecordSelection | null {
  return useContext(RecordSelectionContext);
}
